"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _VerifyRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/VerifyRound"));

// Generated by script, don't edit it please.
var VerifyRound = (0, _createSvgIcon["default"])({
  as: _VerifyRound["default"],
  ariaLabel: 'verify round',
  category: 'status',
  displayName: 'VerifyRound'
});
var _default = VerifyRound;
exports["default"] = _default;
module.exports = exports.default;